import { IconType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import {
  IconDeviceUnknown,
  IconDeviceBlindMotor,
  IconDeviceDinMoble,
  IconDeviceDinModuleWithAntenna,
  IconDeviceRemote,
  IconDeviceRemoteForBlinds,
  IconDeviceRemoteForFacadeBlinds,
  IconDeviceMovementSensor,
  IconDeviceTemperatureSensor,
  IconDeviceHumiditySensor,
  IconDeviceDinPowerMeter,
  IconDeviceIntercom,
  IconDeviceSecurityCamera,
  IconDeviceMultisensor,
  IconDeviceFloodSensor,
  IconDeviceFlushMountedReceiver,
  IconDeviceFlushMountedBlindController,
  IconDeviceFlushMountedDimmer,
  IconDeviceFlushMountedRelay,
  IconDeviceFlushMountedGateController,
  IconDeviceWindSensor,
  IconDeviceFlushMountedGateAndGatewayController,
  IconDeviceAirPressureSensor,
  IconDeviceLightBrightnessSensor,
  IconDeviceReedSensor,
  IconDeviceFlushMountedTransceiver,
  IconDeviceFlushMountedRGBLightController,
  IconDeviceWallMountedThermoregulator,
  IconDeviceImpulseCounter,
  IconDeviceFlushMountedFacadeController,
  IconDeviceWallMountedGateController,
  IconDeviceWallMountedRGBLightController,
  IconDeviceWallMountedDimmer,
  IconDeviceWallMountedRemote,
  IconDeviceDinRelay,
  IconDeviceDinReceiver,
  IconDeviceDinBlindController,
  IconDeviceDinTransceiver,
  IconDeviceSocketPlugIn,
  IconDeviceWallMountedRelay,
  IconDeviceRetransmitter,
} from '../../../../../assets/device-icons';

export const availableIcon = {
  [IconType.Unknown]: <IconDeviceUnknown />,
  [IconType.BlindMotor]: <IconDeviceBlindMotor />,
  [IconType.DinModule]: <IconDeviceDinMoble />,
  [IconType.DinModuleWithAntenna]: <IconDeviceDinModuleWithAntenna />,
  [IconType.Remote]: <IconDeviceRemote />,
  [IconType.RemoteForBlinds]: <IconDeviceRemoteForBlinds />,
  [IconType.RemoteForFacadeBlinds]: <IconDeviceRemoteForFacadeBlinds />,
  [IconType.MovementSensor]: <IconDeviceMovementSensor />,
  [IconType.TemperatureSensor]: <IconDeviceTemperatureSensor />,
  [IconType.HumiditySensor]: <IconDeviceHumiditySensor />,
  [IconType.DinPowerMeter]: <IconDeviceDinPowerMeter />,
  [IconType.Intercom]: <IconDeviceIntercom />,
  [IconType.SecurityCamera]: <IconDeviceSecurityCamera />,
  [IconType.Multisensor]: <IconDeviceMultisensor />,
  [IconType.FloodSensor]: <IconDeviceFloodSensor />,
  [IconType.FlushMountedReceiver]: <IconDeviceFlushMountedReceiver />,
  [IconType.FlushMountedBlindController]: <IconDeviceFlushMountedBlindController />,
  [IconType.FlushMountedDimmer]: <IconDeviceFlushMountedDimmer />,
  [IconType.FlushMountedRelay]: <IconDeviceFlushMountedRelay />,
  [IconType.FlushMountedGateController]: <IconDeviceFlushMountedGateController />,
  [IconType.WindSensor]: <IconDeviceWindSensor />,
  [IconType.FlushMountedGateAndGatewayController]: <IconDeviceFlushMountedGateAndGatewayController />,
  [IconType.AirPressureSensor]: <IconDeviceAirPressureSensor />,
  [IconType.LightBrightnessSensor]: <IconDeviceLightBrightnessSensor />,
  [IconType.ReedSensor]: <IconDeviceReedSensor />,
  [IconType.FlushMountedTransceiver]: <IconDeviceFlushMountedTransceiver />,
  [IconType.FlushMountedRGBLightController]: <IconDeviceFlushMountedRGBLightController />,
  [IconType.WallMountedThermoregulator]: <IconDeviceWallMountedThermoregulator />,
  [IconType.ImpulseCounter]: <IconDeviceImpulseCounter />,
  [IconType.FlushMountedFacadeController]: <IconDeviceFlushMountedFacadeController />,
  [IconType.WallMountedGateController]: <IconDeviceWallMountedGateController />,
  [IconType.WallMountedRGBLightController]: <IconDeviceWallMountedRGBLightController />,
  [IconType.WallMountedDimmer]: <IconDeviceWallMountedDimmer />,
  [IconType.WallMountedRemote]: <IconDeviceWallMountedRemote />,
  [IconType.DinRelay]: <IconDeviceDinRelay />,
  [IconType.DinReceiver]: <IconDeviceDinReceiver />,
  [IconType.DinBlindController]: <IconDeviceDinBlindController />,
  [IconType.DinTransceiver]: <IconDeviceDinTransceiver />,
  [IconType.SocketPlugIn]: <IconDeviceSocketPlugIn />,
  [IconType.WallMountedRelay]: <IconDeviceWallMountedRelay />,
  [IconType.Retransmitter]: <IconDeviceRetransmitter />,
};
